var map = {
	"./Base": 723,
	"./Base/": 723,
	"./Base/index": 723,
	"./Base/index.js": 723,
	"./Base/style": 174,
	"./Base/style.js": 174,
	"./Clutch": 423,
	"./Clutch/": 423,
	"./Clutch/index": 423,
	"./Clutch/index.js": 423,
	"./Clutch/renderComponent": 1651,
	"./Clutch/renderComponent.js": 1651,
	"./Clutch/style": 1293,
	"./Clutch/style.js": 1293,
	"./NewUi": 1015,
	"./NewUi/": 1015,
	"./NewUi/index": 1015,
	"./NewUi/index.js": 1015,
	"./NewUi/style": 1294,
	"./NewUi/style.js": 1294,
	"./OldUi": 1016,
	"./OldUi/": 1016,
	"./OldUi/index": 1016,
	"./OldUi/index.js": 1016,
	"./OldUi/renderComponent": 1652,
	"./OldUi/renderComponent.js": 1652,
	"./OldUi/style": 1295,
	"./OldUi/style.js": 1295,
	"./SpireonNew": 1017,
	"./SpireonNew/": 1017,
	"./SpireonNew/index": 1017,
	"./SpireonNew/index.js": 1017,
	"./SpireonNew/renderComponent": 1653,
	"./SpireonNew/renderComponent.js": 1653,
	"./SpireonNew/style": 1296,
	"./SpireonNew/style.js": 1296,
	"./SpireonOld": 1018,
	"./SpireonOld/": 1018,
	"./SpireonOld/index": 1018,
	"./SpireonOld/index.js": 1018,
	"./SpireonOld/renderComponent": 1654,
	"./SpireonOld/renderComponent.js": 1654,
	"./SpireonOld/style": 1297,
	"./SpireonOld/style.js": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;